import { render, staticRenderFns } from "./ExploreCampus.vue?vue&type=template&id=4121557d&"
import script from "./ExploreCampus.vue?vue&type=script&lang=js&"
export * from "./ExploreCampus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ExploreCampus.vue"
export default component.exports